export function parseJson<T>(value: string | undefined): T | undefined {
	if (!value) {
		return undefined;
	}

	try {
		return JSON.parse(value);
	} catch (error) {
		return undefined;
	}
}

export function stringifyJson<T>(value: T): string {
	return JSON.stringify(value);
}
